import React, { forwardRef, useEffect } from 'react'
import { DAC } from '../interface'
import Input, { InputProps } from '../input'
import './search.css'

export declare interface InputSearchProps extends InputProps {
  timeout?: number;
}

let searchTimeOut: NodeJS.Timeout

// eslint-disable-next-line react/display-name
const Search = forwardRef<unknown, InputSearchProps>((props, ref) => {
  const {
    onChange,
    onClear,
    prefix,
    timeout = 600,
    ...inputProps
  } = props

  const onInput = (ev: DAC.Event & { isClear?: boolean }) => {
    clearTimeout(searchTimeOut)
    if (ev.isClear && onClear) {
      onClear(ev.event)
    }
    if (ev.isClear) {
      onChange?.(ev)
    } else {
      searchTimeOut = setTimeout(() => {
        onChange?.(ev)
      }, timeout)
    }
  }

  useEffect(() => {
    return () => {
      clearTimeout(searchTimeOut)
    }
  }, [])

  return (
    <Input
      onChange={onInput}
      placeholder="请输入关键词搜索"
      prefix={
        prefix || (
          <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            className="zySearchIcon"
          >
            <path d="M448 128a320 320 0 0 1 247.744 522.496l190.912 190.848a32 32 0 0 1-40.832 48.96l-4.48-3.648-190.848-190.912A320 320 0 1 1 448 128z m0 64a256 256 0 1 0 0 512 256 256 0 0 0 0-512z" />
          </svg>
        )
      }
      {...inputProps}
      ref={ref}
    />
  )
})

export default Search
